var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIconWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Error_Icon",
    "data-name": "Error Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #f8f8f8;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #e4001c;\n      }\n\n      .cls-4, .cls-5 {\n        stroke: none;\n      }\n\n      .cls-5 {\n        fill: #e4001c;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4902",
    "data-name": "Rectangle 4902",
    className: "cls-1",
    width: 32,
    height: 32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_10817",
    "data-name": "Path 10817",
    className: "cls-2",
    transform: "translate(8 7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M 8 15.25 C 4.002339839935303 15.25 0.75 11.99765968322754 0.75 8 C 0.75 4.002339839935303 4.002339839935303 0.75 8 0.75 C 11.99765968322754 0.75 15.25 4.002339839935303 15.25 8 C 15.25 11.99765968322754 11.99765968322754 15.25 8 15.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M 8 1.5 C 4.415889739990234 1.5 1.5 4.415889739990234 1.5 8 C 1.5 11.58411026000977 4.415889739990234 14.5 8 14.5 C 11.58411026000977 14.5 14.5 11.58411026000977 14.5 8 C 14.5 4.415889739990234 11.58411026000977 1.5 8 1.5 M 8 0 C 12.41800022125244 0 16 3.581999778747559 16 8 C 16 12.41800022125244 12.41800022125244 16 8 16 C 3.581999778747559 16 0 12.41800022125244 0 8 C 0 3.581999778747559 3.581999778747559 0 8 0 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13347",
    "data-name": "Group 13347",
    transform: "translate(8 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1598",
    "data-name": "Rectangle 1598",
    className: "cls-3",
    width: 1.525,
    height: 1.525,
    transform: "translate(7.238 10.726)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1599",
    "data-name": "Rectangle 1599",
    className: "cls-3",
    width: 1.525,
    height: 5.45,
    transform: "translate(7.238 4.051)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconWhite);
export default __webpack_public_path__ + "static/media/error-icon-white.5a575abe515990c072ded996631c4fcc.svg";
export { ForwardRef as ReactComponent };